import type { ComponentProps } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { mergeCurrentSearchIntoTo } from '../hooks/useDashboardNavigate';

export type DashboardLinkProps = ComponentProps<typeof Link>;

/**
 * react-router's `<Link>` with the current query merged into `to` (DP-3188
 * AC8) — the `<Link>`-shaped half of {@link useDashboardNavigate}, sharing its
 * merge rule verbatim: destination wins on key collision, external and
 * anchor-only targets pass through untouched.
 *
 * Every other prop (including `ref`, `className`, and the `data-*` props Radix
 * `Slot` merges onto an `asChild` child) is spread straight onto `<Link>`, so
 * this drops in wherever `<Link>` is used today.
 */
export function DashboardLink({ to, ...linkProps }: DashboardLinkProps) {
  const { search } = useLocation();

  return <Link to={mergeCurrentSearchIntoTo(to, search)} {...linkProps} />;
}
